import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { authRequest } from '../request/authRequest';

export const CSVDownloadServer = (props: {url: string, fileName: string}) => {

  const descargarArchivo = async(value: any) => {
    
    await authRequest(props.url , { method: 'GET', responseType: 'blob'})
    .then((response: any) => {
      
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', props.fileName); // Nombre del archivo a descargar
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.error('Error al descargar el archivo:', error);
    });
}

  return (
    <div style={{ marginTop: 20 }}>            
        <div>
          <Button type='link' onClick={descargarArchivo}><DownloadOutlined /> Descargar CSV</Button>
        </div>
    </div>
  );
}
